import Header from "./Header";
import {
  Hero, About, WelcomeLongForm, Experience, Retreats, Itinerary, Stay, Team,
  Explore, Dates, Pricing, Testimonials, FAQ, Footer,
} from "./Sections";
import BookingForm from "./BookingForm";

export default function Site() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <WelcomeLongForm />
        <Experience />
        <Retreats />
        <Itinerary />
        <Stay />
        <Team />
        <Explore />
        <Dates />
        <Pricing />
        <Testimonials />
        <FAQ />
        <BookingForm />
      </main>
      <Footer />
    </>
  );
}
